export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
                移动端观影体验
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                棒棒TV完美适配手机和平板，随时随地追剧看片。高清画质、流畅播放，掌中影院就在你身边。无需下载，浏览器打开即看。
              </p>
              <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line"></i> Android 版
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line"></i> iOS 版
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-44 h-80 rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20video%20streaming%20app%20interface%20with%20warm%20coral%20and%20dark%20theme%2C%20clean%20UI%20design%20with%20video%20thumbnails%2C%20minimal%20aesthetic%2C%20mobile%20app%20screen%20on%20device%2C%20soft%20lighting%2C%20white%20background%2C%20product%20photography%20style&width=440&height=800&seq=app-mobile-bbtv&orientation=portrait"
                  alt="棒棒TV移动端观影体验"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}